import { c as _c } from "react/compiler-runtime";
import { Field } from '@algoacademy/design-system/web/forms/Fieldset/Field';
import { Label } from '@algoacademy/design-system/web/forms/Fieldset/Label';
import { Textarea } from '@algoacademy/design-system/web/forms/Textarea';
import type { ChangeEvent } from 'react';
type DiscountReasonFieldProps = {
  reason: string;
  onChange: (reason: string) => void;
};

/**
 * Never required, but the only place the story behind a discount survives, so the
 * remaining room is said out loud instead of the box silently refusing more typing.
 */
export function DiscountReasonField(t0) {
  const $ = _c(6);
  const {
    reason,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Label>Powód zniżki (opcjonalny)</Label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChange) {
    t2 = event => onChange(event.target.value);
    $[1] = onChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== reason || $[4] !== t2) {
    t3 = <Field>{t1}<Textarea rows={3} value={reason} onChange={t2} /></Field>;
    $[3] = reason;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}